<template>

    <span class="traplinkedNotificationWrapper" v-if="value">
      <div class="row">
        <div class="col-md-6">

          <b-form-checkbox
              v-if="customer.cardcode != 'ALLE'"
              :id="'checkbox-traplinkedNotification-' + value.name + '-customer-' + (customer ? customer.id : '')"
              v-model="isChecked"
              @change="toggleChecked"
              name="'checkbox-traplinkedNotification-' + value.name"
              value="true"
              unchecked-value="false">
                {{ value.label }}
          </b-form-checkbox>
          <div v-else>
            <b-button size="sm"
                      class="notification-btn-status mr-2"
                      :variant="isChecked === true ? 'success' : (isChecked === false ? 'danger' : 'primary')"
                      v-b-tooltip.hover.top
                      :title="isChecked === true ? $t('message.customerNotifications_fuer_alle_desc') : (isChecked === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
              <span class="notification-btn-status-icon">
                <b-icon :icon="isChecked === true ? 'check-circle-fill' : (isChecked === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
              </span>
              <span class="notification-btn-status-label">
                {{ isChecked === true ? $t('message.customerNotifications_status_aktiviert') : (isChecked === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
              </span>
            </b-button>
            <b-button-group
                size="sm"
                class="notification-btn-actions"
                :id="'checkbox-traplinkedNotification-' + value.name + '-customer-' + (customer ? customer.id : '')">
              <b-button v-if="isChecked !== true"
                        variant="outline-success"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                        @click="setIsChecked(true)">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button v-if="isChecked !== false"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                        @click="setIsChecked(false)">
                <b-icon icon="dash-circle-fill"></b-icon>
              </b-button>
            </b-button-group>
            &nbsp;<label :for="'checkbox-traplinkedNotification-' + value.name + '-customer-' + (customer ? customer.id : '')">
              {{ value.label }}
             </label>
          </div>
          <!-- bei Sensor- und Tür-Alarm kann die Histerese/Zustellungssperre konfiguriert werden -->
          <div v-if="(value.name == 'SENSOR_ALARM' || value.name == 'DOOR_ALARM') && (isChecked === 'true' || isChecked === true)" class="ml-4 mt-2 mb-4">
              <template v-if="value.name == 'SENSOR_ALARM'">
                <p class="notification-section-hint">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('message.sensor_alarm_histerese_desc') }}
                </p>
                <label :for="'histerese-' + value.name + '-customer-' + (customer ? customer.id : '')">
                  {{ $t('message.sensor_alarm_nach') }}
                  <b-form-input
                      :id="'histerese-' + value.name + '-customer-' + (customer ? customer.id : '')"
                      v-model="histerese"
                      style="max-width: 100px; display: inline-flex;"
                      type="number"
                      min="0"
                      step="1"
                      class="ml-2 mr-2 form-control"
                      @blur="saveHisterese(histerese, null)"
                  /> {{ $t('message.sensor_alarm_minuten') }}.
                </label>
              </template>
              <template v-else>
                <p class="notification-section-hint">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('message.door_alarm_histerese_desc') }}
                </p>
              </template>
              <div>
                <label class="mb-1">{{ $t('message.quiet_hours_label') }}</label><br/>
                <p class="notification-section-hint">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('message.quiet_hours_desc') }}
                </p>
                <b-form-checkbox-group
                    :id="'quietDays-' + value.name + '-customer-' + (customer ? customer.id : '')"
                    v-model="quietDays"
                    :options="dayOptions"
                    @change="saveQuietHours(false)"
                />
                <br/>
                <b-form-timepicker
                    :id="'quietTimeFrom-' + value.name + '-customer-' + (customer ? customer.id : '')"
                    v-model="quietTimeFrom"
                    minutes-step="30"
                    size="sm"
                    :placeholder="$t('message.quiet_hours_von')"
                    style="max-width: 140px; display: inline-flex;"
                    class="mr-2"
                    @input="saveQuietHours(false)"
                />
                {{ $t('message.quiet_hours_bis') }}
                <b-form-timepicker
                    :id="'quietTimeTo-' + value.name + '-customer-' + (customer ? customer.id : '')"
                    v-model="quietTimeTo"
                    minutes-step="30"
                    size="sm"
                    :placeholder="$t('message.quiet_hours_bis')"
                    style="max-width: 140px; display: inline-flex;"
                    class="mr-2 ml-2"
                    @input="saveQuietHours(false)"
                />
              </div>
          </div>

        </div>
        <div class="col-md-6">

          <b-form-checkbox
              v-if="customer.cardcode != 'ALLE'"
              :id="'checkbox-traplinkedNotification-app-' + value.name + '-customer-' + (customer ? customer.id : '')"
              v-model="isCheckedApp"
              @change="toggleCheckedApp"
              name="'checkbox-traplinkedNotification-app-' + value.name"
              value="true"
              unchecked-value="false">
              {{ value.labelApp }}
          </b-form-checkbox>
          <div v-else>
            <b-button size="sm"
                      class="notification-btn-status mr-2"
                      :variant="isCheckedApp === true ? 'success' : (isCheckedApp === false ? 'danger' : 'primary')"
                      v-b-tooltip.hover.top
                      :title="isCheckedApp === true ? $t('message.customerNotifications_fuer_alle_desc') : (isCheckedApp === false ? $t('message.customerNotifications_fuer_alle_inaktiv_desc') : $t('message.customerNotifications_fuer_andere_desc'))">
              <span class="notification-btn-status-icon">
                <b-icon :icon="isCheckedApp === true ? 'check-circle-fill' : (isCheckedApp === false ? 'dash-circle-fill' : 'sliders')"></b-icon>
              </span>
              <span class="notification-btn-status-label">
                {{ isCheckedApp === true ? $t('message.customerNotifications_status_aktiviert') : (isCheckedApp === false ? $t('message.customerNotifications_status_deaktiviert') : $t('message.customerNotifications_status_individuell')) }}
              </span>
            </b-button>
            <b-button-group
                size="sm"
                class="notification-btn-actions"
                :id="'checkbox-traplinkedNotification-app-' + value.name + '-customer-' + (customer ? customer.id : '')">
              <b-button v-if="isCheckedApp !== true"
                        variant="outline-success"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_aktivieren')"
                        @click="setIsCheckedApp(true)">
                <b-icon icon="check-circle-fill"></b-icon>
              </b-button>
              <b-button v-if="isCheckedApp !== false"
                        variant="outline-danger"
                        v-b-tooltip.hover.top
                        :title="$t('message.customerNotifications_fuer_alle_deaktivieren')"
                        @click="setIsCheckedApp(false)">
                <b-icon icon="dash-circle-fill"></b-icon>
              </b-button>
            </b-button-group>
            &nbsp;<label :for="'checkbox-notificationNeuerMangel-app-' + (customer ? customer.id : '')">
               {{ value.labelApp }}
             </label>
          </div>
          <!-- bei Sensor- und Tür-Alarm kann die Histerese/Zustellungssperre konfiguriert werden -->
          <div v-if="(value.name == 'SENSOR_ALARM' || value.name == 'DOOR_ALARM') && (isCheckedApp === 'true' || isCheckedApp === true)" class="ml-4 mt-2 mb-4">
              <template v-if="value.name == 'SENSOR_ALARM'">
                <p class="notification-section-hint">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('message.sensor_alarm_histerese_desc') }}
                </p>
                <label :for="'histereseApp-' + value.name + '-customer-' + (customer ? customer.id : '')">
                  {{ $t('message.sensor_alarm_nach') }}
                  <b-form-input
                      :id="'histereseApp-' + value.name + '-customer-' + (customer ? customer.id : '')"
                      v-model="histereseApp"
                      style="max-width: 100px; display: inline-flex;"
                      type="number"
                      min="0"
                      step="1"
                      @blur="saveHisterese(null, histereseApp)"
                      class="ml-2 mr-2 form-control"
                  /> {{ $t('message.sensor_alarm_minuten') }}.
                </label>
              </template>
              <template v-else>
                <p class="notification-section-hint">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('message.door_alarm_histerese_desc') }}
                </p>
              </template>
              <div>
                <label class="mb-1">{{ $t('message.quiet_hours_label') }}</label><br/>
                <p class="notification-section-hint">
                  <b-icon icon="info-circle"></b-icon>
                  {{ $t('message.quiet_hours_desc') }}
                </p>
                <b-form-checkbox-group
                    :id="'quietDaysApp-' + value.name + '-customer-' + (customer ? customer.id : '')"
                    v-model="quietDaysApp"
                    :options="dayOptions"
                    @change="saveQuietHours(true)"
                />
                <br/>
                <b-form-timepicker
                    :id="'quietTimeFromApp-' + value.name + '-customer-' + (customer ? customer.id : '')"
                    v-model="quietTimeFromApp"
                    minutes-step="30"
                    size="sm"
                    :placeholder="$t('message.quiet_hours_von')"
                    style="max-width: 140px; display: inline-flex;"
                    class="mr-2"
                    @input="saveQuietHours(true)"
                />
                {{ $t('message.quiet_hours_bis') }}
                <b-form-timepicker
                    :id="'quietTimeToApp-' + value.name + '-customer-' + (customer ? customer.id : '')"
                    v-model="quietTimeToApp"
                    minutes-step="30"
                    size="sm"
                    :placeholder="$t('message.quiet_hours_bis')"
                    style="max-width: 140px; display: inline-flex;"
                    class="mr-2 ml-2"
                    @input="saveQuietHours(true)"
                />
              </div>
          </div>

        </div>
      </div>
    </span>

</template>

<script>

    import axios from 'axios'
    import bootbox from 'bootbox'
    axios.defaults.withCredentials = true

    export default {
      name: 'TraplinkedNotification',
      props: [
        'value',
         /** customer kann auch ein Objekt mit ID 'ALLE' sein, um für alle Standorte des Keyusers Werte zu setzen */
        'customer',
      ],
      data () {
        return {
          isChecked: null,
          isCheckedApp: null,
          histerese: null,
          histereseApp: null,
          quietTimeFrom: null,
          quietTimeTo: null,
          quietDays: [],
          quietTimeFromApp: null,
          quietTimeToApp: null,
          quietDaysApp: [],
          /** wird auf true gesetzt wenn init durchgelaufen ist */
          initFinished: false,
        }
      },
      computed: {
        dayOptions () {
          return [
            { text: this.$t('message.quiet_hours_mo'), value: 'MO' },
            { text: this.$t('message.quiet_hours_di'), value: 'DI' },
            { text: this.$t('message.quiet_hours_mi'), value: 'MI' },
            { text: this.$t('message.quiet_hours_do'), value: 'DO' },
            { text: this.$t('message.quiet_hours_fr'), value: 'FR' },
            { text: this.$t('message.quiet_hours_sa'), value: 'SA' },
            { text: this.$t('message.quiet_hours_so'), value: 'SO' },
          ]
        }
      },
      watch: {

        '$store.state.allEmailNotificationInactive': function () {
          console.log('allEmailNotificationInactive', this.$store.state.allEmailNotificationInactive)
          this.init()
        },
        '$store.state.allEmailNotificationActive': function () {
          console.log('allEmailNotificationActive', this.$store.state.allEmailNotificationActive)
          this.init()
        },
        '$store.state.allAppNotificationInactive': function () {
          console.log('allAppNotificationInactive', this.$store.state.allAppNotificationInactive)
          this.init()
        },
        '$store.state.allAppNotificationActive': function () {
          console.log('allAppNotificationActive', this.$store.state.allAppNotificationActive)
          this.init()
        }

      },
      created() {

        this.isChecked        = this.value.checked
        this.isCheckedApp     = this.value.checkedApp
        this.histerese        = this.value.histerese
        this.histereseApp     = this.value.histereseApp
        this.quietTimeFrom    = this.value.quietTimeFrom    || null
        this.quietTimeTo      = this.value.quietTimeTo      || null
        this.quietDays        = (this.value.quietDays || '').split(',').filter(Boolean)
        this.quietTimeFromApp = this.value.quietTimeFromApp || null
        this.quietTimeToApp   = this.value.quietTimeToApp   || null
        this.quietDaysApp     = (this.value.quietDaysApp || '').split(',').filter(Boolean)
        this.init()

      },
      methods: {

        toggleCheckedApp: function() {

          console.log('toggleCheckedApp', this.isCheckedApp)
          this.change(null, this.isCheckedApp)

        },
        toggleChecked: function() {

          console.log('toggleChecked', this.isChecked)
          this.change(this.isChecked, null)

        },
        setIsChecked: function (newVal) {

          console.log('setIsChecked newVal = ' + newVal + ' oldVal = ' + this.isChecked)
          if (newVal == null || newVal === this.isChecked) return
          this.confirmIfAlle(newVal, () => this.change(newVal, null))

        },
        setIsCheckedApp: function(newVal) {

          console.log('newVal = ' + newVal + ' oldVal = ' + this.isCheckedApp)
          if (newVal == null || newVal === this.isCheckedApp) return
          this.confirmIfAlle(newVal, () => this.change(null, newVal))

        },
        confirmIfAlle: function (newVal, onConfirm) {

          if (this.customer && this.customer.cardcode === 'ALLE') {
            const key = newVal
                ? 'message.customerNotifications_fuer_alle_aktivieren_confirm'
                : 'message.customerNotifications_fuer_alle_deaktivieren_confirm'
            bootbox.confirm(this.$t(key), result => {
              if (result) onConfirm()
            })
          } else {
            onConfirm()
          }

        },
        /** hole die Daten neu aus der Datenbank */
        init: function () {

          const that = this
          const url = process.env.VUE_APP_SERVER_URL + '/notification/getTraplinkedNotification'
          let mandant = null
          if (this.customer) {
            mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
          }
          const params = {
            cardcode:               this.customer ? this.customer.cardcode : null,
            mandant:                this.customer ? mandant : null,
            biotechUser_id:         this.$store.getters.user.id,
            traplinkedNotification: this.value.name,
          }
          axios({
            method: 'GET',
            params: params,
            url: url,
          }).then( response => {

            console.log('Traplinked Notififation Ausnahme gelesen', response.data)
            that.isChecked     = response.data.isChecked
            that.isCheckedApp  = response.data.isCheckedApp
            that.initFinished  = true

          }).catch(error => {
            console.log(error)
          })

        },
        /**
         * Histerese Wert speichern
         * @param newVal
         */
        saveHisterese: function (newVal, newValApp) {

          console.log('saveHisterese', newVal, newValApp)
          if (newVal != this.value.histerese || newValApp != this.value.histereseApp) {

            const that = this
            const url     = process.env.VUE_APP_SERVER_URL + '/notification/saveHisterese'
            let mandant = null
            if (this.customer) {
              mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            }
            const params  = {
              cardcode:             this.customer ? this.customer.cardcode : null,
              mandant:              this.customer ? mandant : null,
              biotechUser_id:       this.$store.getters.user.id,
              histerese:            newVal,
              histereseApp:         newValApp,
            }
            axios({
              method: 'GET',
              params: params,
              url: url
            }).then(() => {

              console.log('Histerese gespeichert.')
              if (that.customer.cardcode == 'ALLE') {

                let title = that.$t('message.customerNotifications_fuer_alle_aktivieren')
                let text = that.$t('message.customerNotifications_fuer_alle_aktivieren_ok')
                if (newVal === false || newValApp === false) {
                  title = that.$t('message.customerNotifications_fuer_alle_deaktivieren')
                  text = that.$t('message.customerNotifications_fuer_alle_deaktivieren_ok')
                }
                that.$bvToast.toast(text, {
                  title: title,
                  variant: 'success',
                  autoHideDelay: 3000,
                })

              }
              that.hideSpinner()

            }).catch(error => {
              console.log(error)
              that.$bvToast.toast(that.$t('message.customerNotifications_fuer_alle_deaktivieren_fail'), {
                title: 'Error',
                variant: 'success',
                autoHideDelay: 5000
              })
              that.hideSpinner()
            })

          }

        },
        /**
         * Ruhezeiten (Zeitfenster + Wochentage) speichern
         * @param isApp true = App-Push Kanal, false = Email Kanal
         */
        saveQuietHours: function (isApp) {

          const that = this
          const url = process.env.VUE_APP_SERVER_URL + '/notification/saveQuietHours'
          let mandant = null
          if (this.customer) {
            mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
          }
          const params = {
            cardcode:         this.customer ? this.customer.cardcode : null,
            mandant:          this.customer ? mandant : null,
            biotechUser_id:   this.$store.getters.user.id,
            quietTimeFrom:    !isApp ? (this.quietTimeFrom || '') : null,
            quietTimeTo:      !isApp ? (this.quietTimeTo || '') : null,
            quietDays:        !isApp ? this.quietDays.join(',') : null,
            quietTimeFromApp: isApp ? (this.quietTimeFromApp || '') : null,
            quietTimeToApp:   isApp ? (this.quietTimeToApp || '') : null,
            quietDaysApp:     isApp ? this.quietDaysApp.join(',') : null,
          }
          axios({
            method: 'GET',
            params: params,
            url: url
          }).then(() => {

            console.log('Ruhezeiten gespeichert.')
            // SENSOR_ALARM und DOOR_ALARM teilen sich dieselben Ruhezeiten-Felder,
            // laufen aber als getrennte Komponenten - Geschwister-Zeile zum Refresh anstoßen
            that.$emit('quiet-hours-saved')
            that.hideSpinner()

          }).catch(error => {
            console.log(error)
            that.hideSpinner()
          })

        },
        change: function (newVal, newValApp) {

          this.showSpinner()
          const that = this
          console.log('isChecked geändert auf ' + newVal + ' ' + newValApp)
          if (newVal === 'true' || newValApp === 'true' || newVal === true || newValApp === true) {

            const url     = process.env.VUE_APP_SERVER_URL + '/notification/saveTraplinkedNotification'
            let mandant = null
            if (this.customer) {
              mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            }
            const params  = {
              cardcode:             this.customer ? this.customer.cardcode : null,
              mandant:              this.customer ? mandant : null,
              biotechUser_id:       this.$store.getters.user.id,
            }
            if (newVal === 'true' || newVal === true) {
              params.notification = this.value.name
            } else if (newValApp === 'true' || newValApp === true) {
              params.notificationApp = this.value.name
            }

            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function () {

              console.log('Traplinked Notififation Ausnahme gespeichert.')
              if (that.customer.cardcode == 'ALLE') {

                let title = that.$t('message.customerNotifications_fuer_alle_aktivieren')
                let text = that.$t('message.customerNotifications_fuer_alle_aktivieren_ok')
                if (newVal === false || newValApp === false) {
                  title = that.$t('message.customerNotifications_fuer_alle_deaktivieren')
                  text = that.$t('message.customerNotifications_fuer_alle_deaktivieren_ok')
                }
                that.$bvToast.toast(text, {
                  title: title,
                  variant: 'success',
                  autoHideDelay: 3000,
                })
                if (newVal != null) {
                  that.isChecked    = newVal
                }
                if (newValApp != null) {
                  that.isCheckedApp = newValApp
                }

              }
              that.hideSpinner()

            }).catch(error => {
              console.log(error)
              that.$bvToast.toast(that.$t('message.customerNotifications_fuer_alle_deaktivieren_fail'), {
                title: 'Error',
                variant: 'success',
                autoHideDelay: 5000
              })
              that.hideSpinner()
            })

          } else {

            const url     = process.env.VUE_APP_SERVER_URL + '/notification/deleteTraplinkedNotification'
            let mandant = null
            if (this.customer) {
              mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            }
            const params  = {
              cardcode:             this.customer ? this.customer.cardcode : null,
              mandant:              this.customer ? mandant : null,
              biotechUser_id:       this.$store.getters.user.id,
            };
            if (newVal === 'false' || newVal === false) {
              params.notification = this.value.name
            } else if (newValApp === 'false' || newValApp === false) {
              params.notificationApp = this.value.name
            }
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function () {

              console.log('Traplinked Notififation gelöscht.')
              if (that.customer.cardcode == 'ALLE') {

                let title = that.$t('message.customerNotifications_fuer_alle_aktivieren')
                let text = that.$t('message.customerNotifications_fuer_alle_aktivieren_ok')
                if (newVal === false || newValApp === false) {
                  title = that.$t('message.customerNotifications_fuer_alle_deaktivieren')
                  text = that.$t('message.customerNotifications_fuer_alle_deaktivieren_ok')
                }
                that.$bvToast.toast(text, {
                  title: title,
                  variant: 'success',
                  autoHideDelay: 3000,
                })
                // nur den jeweils geänderten State aktualisieren —
                // E-Mail und App Push sind unabhängig voneinander
                if (newVal != null) {
                  that.isChecked = newVal
                }
                if (newValApp != null) {
                  that.isCheckedApp = newValApp
                }

              }
              that.hideSpinner()

            }).catch(error => {
              console.log(error)
              that.$bvToast.toast(that.$t('message.customerNotifications_fuer_alle_deaktivieren_fail'), {
                title: 'Error',
                variant: 'success',
                autoHideDelay: 5000
              })
              that.hideSpinner()
            })

          }

        }

      }

    }

</script>
